import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/loader'
import Dialoguemodal from 'components/dialoguemodal'
import ConfirmationModal from 'components/confimation-modal'
import { branchesApi } from '../restaurant.api'
import { BranchesProvider, useBranches } from './branches.context'
import BranchForm from './branch-form'

function BranchCard({ branch, onEdit, onDelete }) {
  return (
    <div className='tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-bg-white tw-p-4'>
      <div className='tw-flex tw-items-start tw-justify-between tw-gap-2'>
        <h3 className='tw-font-semibold tw-text-[15px]'>{branch.name}</h3>
        <span
          className={`tw-text-[10px] tw-px-[7px] tw-py-[2px] tw-rounded-[3px] tw-capitalize ${branch.status === 'active' ? 'tw-bg-[#E6F0E9] tw-text-[#3F7A56]' : 'tw-bg-gray-100 tw-text-gray-500'}`}
        >
          {branch.status}
        </span>
      </div>
      <p className='tw-mt-1 tw-text-sm tw-text-gray-500'>{branch.address}</p>
      <p className='tw-mt-1 tw-text-sm tw-text-gray-500'>📞 {branch.contactNumber}</p>
      {branch.workingHours && (
        <p className='tw-text-sm tw-text-gray-500'>🕒 {branch.workingHours}</p>
      )}
      <div className='tw-mt-3 tw-flex tw-gap-2'>
        <button
          type='button'
          onClick={() => onEdit(branch)}
          className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-gray-300 tw-text-gray-600'
        >
          Edit
        </button>
        <button
          type='button'
          onClick={() => onDelete(branch)}
          className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-[#FBE9E7] tw-text-[#C0392B]'
        >
          Delete
        </button>
      </div>
    </div>
  )
}

function BranchesInner() {
  const { loading, branches, refresh } = useBranches()
  const navigate = useNavigate()
  const [formOpen, setFormOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [deleting, setDeleting] = useState(null)

  const openCreate = () => {
    setEditing(null)
    setFormOpen(true)
  }

  const openEdit = (branch) => {
    setEditing(branch)
    setFormOpen(true)
  }

  const confirmDelete = async () => {
    const { response } = await branchesApi.remove(deleting._id)
    if (response?.success) await refresh()
    setDeleting(null)
  }

  return (
    <div>
      <div className='tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-4'>
        <div>
          <button
            onClick={() => navigate('/order-management')}
            className='tw-text-[12px] tw-text-gray-400'
          >
            ← Order management
          </button>
          <h2 className='font-heading tw-text-2xl'>Store Locations</h2>
        </div>
        <button
          onClick={openCreate}
          className='tw-rounded-[6px] tw-bg-electricGreen tw-text-white tw-text-regular tw-py-[8px] tw-px-[20px] tw-whitespace-nowrap'
        >
          + Add location
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : branches.length ? (
        <div className='tw-grid tw-gap-4 md:tw-grid-cols-2'>
          {branches.map((branch) => (
            <BranchCard
              key={branch._id}
              branch={branch}
              onEdit={openEdit}
              onDelete={setDeleting}
            />
          ))}
        </div>
      ) : (
        <div className='tw-text-center tw-text-gray-400 tw-py-16'>
          No store locations yet
        </div>
      )}

      <Dialoguemodal
        open={formOpen}
        onClose={() => setFormOpen(false)}
        title={editing ? 'Edit location' : 'Create location'}
      >
        {formOpen && (
          <BranchForm branch={editing} onClose={() => setFormOpen(false)} />
        )}
      </Dialoguemodal>

      <ConfirmationModal
        open={!!deleting}
        onClose={() => setDeleting(null)}
        onConfirm={confirmDelete}
      >
        <div className='tw-mb-4'>
          <h3 className='tw-text-lg tw-font-semibold tw-mb-1'>Delete location</h3>
          <p className='tw-text-sm tw-text-gray-500'>
            Are you sure you want to delete “{deleting?.name}”?
          </p>
        </div>
      </ConfirmationModal>
    </div>
  )
}

function Branches() {
  return (
    <BranchesProvider>
      <BranchesInner />
    </BranchesProvider>
  )
}

export default Branches
